import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

export interface HelpDialogData {
  topic?: string;
  feature?: string;
}

@Component({
  selector: 'app-help-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule
  ],
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent implements OnInit {
  selectedTopic: string = 'data-profiler';

  constructor(
    public dialogRef: MatDialogRef<HelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HelpDialogData
  ) {}

  ngOnInit(): void {
    if (this.data?.topic) {
      this.selectedTopic = this.data.topic;
    } else if (this.data?.feature) {
      // Map feature names to topic IDs
      const featureMap: { [key: string]: string } = {
        'profile-data': 'data-profiler',
        'anomaly-detection': 'anomaly-detection',
        'ai-readiness': 'ai-readiness',
        'clean-data': 'project-canvas',
        'hypothesis-testing': 'hypothesis-testing'
      };
      this.selectedTopic = featureMap[this.data.feature] || 'data-profiler';
    }
  }

  onTopicSelect(topic: string): void {
    this.selectedTopic = topic;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
